import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

import "./footer.styles.scss";

export default function Footer({ style, ...rest }) {
  return (
    <div className="footer" style={style} {...rest}>
      <div className="options">
        <p>
          © 2021 TeamFreaksNGeeks MADE WITH{" "}
          <FontAwesomeIcon
            icon={faHeart}
            style={{ color: "red", marginLeft: 5 }}
          />
        </p>
      </div>
    </div>
  );
}
